import { Navigate, Outlet, type To } from 'react-router-dom';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import {
  canUseLegacyProspectionMap,
  canUseProspectionMapV2,
  prospectionMapPath,
} from '@shared/utils/prospectionMapAccess';

// Same rule as the sidebar (prospectionMapAccess), so a pasted or emailed link
// cannot open a map the user does not have. The server gates the new map's
// data on the module as well; this only keeps the page consistent with it.
export const ProspectionMapRoute: React.FC<{
  map: 'legacy' | 'v2';
  redirectTo?: To;
}> = ({ map, redirectTo }) => {
  const { me } = useAppData();
  const allowed =
    me != null &&
    (map === 'v2'
      ? canUseProspectionMapV2(me)
      : canUseLegacyProspectionMap(me));

  // Refused here but entitled to the other map: open that one. The n8n
  // new-leads emails link to /v2/maps → /maps, and an agent who only bought
  // the new map would otherwise land on the dashboard.
  const otherMap = me != null ? prospectionMapPath(me) : null;

  return allowed ? (
    <Outlet />
  ) : (
    <Navigate to={redirectTo ?? otherMap ?? '/dashboard'} replace />
  );
};
